import React from "react";
import { Link } from "react-router-dom";
import { Award } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const CourseCertificateCta = ({ ctx, lessonId, testId = "lesson-certificate-cta" }) => {
  const { progress } = useAuth();
  if (!ctx) return null;
  const lessons = ctx.course.lessons;
  if (lessons[lessons.length - 1]?.id !== lessonId) return null;
  const done = new Set(progress?.completed_lessons || []);
  const left = lessons.filter((l) => !done.has(l.id)).length;
  const url = `/certificate/${ctx.instrument.id}/${ctx.course.id}`;
  return (
    <div className="mt-6 flex flex-col items-start justify-between gap-4 rounded-2xl border border-primary/40 bg-primary/10 p-5 sm:flex-row sm:items-center" data-testid={testId}>
      <div className="flex items-start gap-3">
        <Award size={26} className="mt-0.5 shrink-0 text-primary" />
        <div>
          <p className="font-serif text-lg">{left ? "Your course certificate" : "You've finished the course!"}</p>
          <p className="text-sm text-muted-foreground" data-testid={`${testId}-text`}>
            {left ? `Complete all ${lessons.length} lessons to earn your ${ctx.instrument.label} ${ctx.course.tagline} certificate — ${left} to go.` : `Your ${ctx.instrument.label} ${ctx.course.tagline} certificate is ready to download and print.`}
          </p>
        </div>
      </div>
      {!left && (
        <Link to={url} data-testid={`${testId}-link`} className="inline-flex items-center gap-1.5 rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-transform hover:scale-105">
          <Award size={15} /> Get your certificate
        </Link>
      )}
    </div>
  );
};
